module.exports = __webpack_public_path__ + "static/media/wrapped_gift.ccf404b0.png";